var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderHorizontalGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 35,
    width: 15,
    height: 30,
    fill: "#383B42"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "21.5;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "57;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 35,
    width: 15,
    height: 30,
    fill: "#383B42"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "24.875000000000004;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "50.24999999999999;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 35,
    width: 15,
    height: 30,
    fill: "#383B42"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "24.875000000000004;35;35",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "50.24999999999999;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderHorizontalGrey);
export default __webpack_public_path__ + "static/media/loader-horizontal-grey.20322918c7df4d7ea78675898ccaf4ff.svg";
export { ForwardRef as ReactComponent };